import Link from 'next/link'

const ErrorPage = (props: any) => {
  return (
    <>
      <h1>Error</h1>
      <pre>{JSON.stringify(props)}</pre>
      <Link href="/">
        <a>Go back home</a>
      </Link>
    </>
  )
}

export default ErrorPage
